const NotFoundPage = () => {
  return (
    <div className="flex-page-center">
      <h2 className="page--header text--alert">Запрашиваемая страница не найдена :(</h2>
    </div>
  )
}

export default NotFoundPage
